import endpoints from "../data/endpoints";
import { PdfDownloadPayload } from "../types/types";
import apiRequest from "./apiRequest";

export const requestPdfDownload = async (
	payload: PdfDownloadPayload,
): Promise<Blob> => {
	return (await apiRequest(endpoints.pdfDownload.url, {
		method: endpoints.pdfDownload.requestMethod,
		body: JSON.stringify(payload),
	})) as Blob;
};
